import { DumbCardBack } from 'components/card/Back/DumbCardBack';
import { FRONTEND_ASSET_HOST } from 'constants/assets';

export const BackBoxReward = () => {
  return (
    <DumbCardBack
      path={`${FRONTEND_ASSET_HOST}/cards/back/box.png`}
      aria-label="Box"
      radius="10px"
    />
  );
};
